module.exports = __webpack_public_path__ + "img/hello_world.0f0cd8d1.png";